"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const R2BTopNavCashIcon = createSVGIcon(
  <>
    <rect
      opacity="0.6"
      x="0.53125"
      y="18.4683"
      width="26.118"
      height="26.118"
      transform="rotate(-45 0.53125 18.4683)"
      fill="white"
    />
    <rect
      opacity="0.6"
      x="0.53125"
      y="18.4685"
      width="26.118"
      height="26.118"
      transform="rotate(-45 0.53125 18.4685)"
      fill="#C9D3C5"
    />
    <path
      d="M19.0922 18.0698V18.0593C19.081 17.5673 19.5071 17.1903 20.2696 17.1171V19.1273C19.3165 18.8551 19.0922 18.5514 19.0922 18.0698ZM22.3776 21.6296V21.6505C22.3776 22.195 21.9403 22.5509 21.1666 22.6242V20.5616C22.1085 20.8234 22.3776 21.1375 22.3776 21.6296ZM23.4092 16.9181C22.7589 16.4679 22.0637 16.1852 21.2115 16.091V15.4314H20.2247V16.0701C18.767 16.1748 17.7803 16.9705 17.7803 18.1326V18.1536C17.7803 19.3681 18.5652 19.9544 20.2696 20.3627V22.5823C19.4959 22.4672 18.8567 22.1321 18.1952 21.6191L17.4775 22.5719C18.2625 23.1687 19.2043 23.556 20.2247 23.6607V24.7496H21.2115V23.6817C22.6916 23.556 23.6896 22.7708 23.6896 21.5772V21.5563C23.7008 20.3941 22.9271 19.745 21.1666 19.3367V17.1799C21.7049 17.2846 22.2431 17.5358 22.7701 17.8918L23.4092 16.9181Z"
      fill="#333333"
    />
    <rect
      x="7.49756"
      y="12.4998"
      width="26"
      height="15"
      fill="#DFE5DC"
      stroke="#333333"
      strokeLinejoin="round"
    />
    <rect
      x="7.49951"
      y="12.4996"
      width="26"
      height="15"
      stroke="#333333"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.4498 13C16.4097 13.0486 16.3658 13.103 16.3188 13.1632C16.066 13.4862 15.7227 13.9717 15.3779 14.6039C14.6881 15.8685 14 17.7045 14 20C14 22.2955 14.6881 24.1315 15.3779 25.3961C15.7227 26.0283 16.066 26.5138 16.3188 26.8368C16.3658 26.897 16.4097 26.9514 16.4498 27H24.5502C24.5903 26.9514 24.6342 26.897 24.6812 26.8368C24.934 26.5138 25.2773 26.0283 25.6221 25.3961C26.3119 24.1315 27 22.2955 27 20C27 17.7045 26.3119 15.8685 25.6221 14.6039C25.2773 13.9717 24.934 13.4862 24.6812 13.1632C24.6342 13.103 24.5903 13.0486 24.5502 13H16.4498ZM25 28C25 28 28 25 28 20C28 15 25 12 25 12H16C16 12 13 15 13 20C13 25 16 28 16 28H25ZM24.2904 27.2954L24.2905 27.2953C24.2904 27.2954 24.2904 27.2954 24.2904 27.2954ZM16.7078 27.2936C16.7088 27.2946 16.7093 27.2951 16.7095 27.2953L16.7089 27.2947L16.7081 27.2939M16.7096 27.2954C16.7096 27.2954 16.7096 27.2954 16.7095 27.2953Z"
      fill="#333333"
    />
    <path
      d="M18.6147 18.0697V18.0592C18.6035 17.5671 19.0296 17.1902 19.792 17.1169V19.1271C18.8389 18.8549 18.6147 18.5513 18.6147 18.0697ZM21.9001 21.6295V21.6504C21.9001 22.1948 21.4628 22.5508 20.6891 22.6241V20.5615C21.631 20.8233 21.9001 21.1374 21.9001 21.6295ZM22.9317 16.918C22.2813 16.4678 21.5861 16.1851 20.7339 16.0909V15.4313H19.7472V16.0699C18.2895 16.1746 17.3028 16.9704 17.3028 18.1325V18.1534C17.3028 19.368 18.0877 19.9543 19.792 20.3626V22.5822C19.0183 22.467 18.3792 22.132 17.7176 21.619L17 22.5717C17.7849 23.1685 18.7268 23.5559 19.7472 23.6606V24.7495H20.7339V23.6816C22.2141 23.5559 23.212 22.7707 23.212 21.5771V21.5562C23.2232 20.394 22.4495 19.7449 20.6891 19.3365V17.1797C21.2273 17.2844 21.7655 17.5357 22.2926 17.8917L22.9317 16.918Z"
      fill="#333333"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 9H31V9.9697H4.98182V25H4V9Z"
      fill="#333333"
    />
  </>,
  "R2BTopNavCashIcon",
  { viewBox: "0 0 38 37", titleAccess: "R2BTopNavCashIcon", fill: "none" }
);
